var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{class:_vm.$style.page,attrs:{"no-toolbar":""}},[_c('f7-navbar',{attrs:{"no-shadow":"","no-hairline":"","back-link":_vm.$t('global.navbar.back')}},[_c('f7-nav-title',[_vm._v(_vm._s(_vm.pageTitle))])],1),_c('BranchList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }